export default class AdminNotificacionLicenciaLista {

    /**
     *
     * @param {number} props.notificacionId
     * @param {Array} props.grados
     * @param {Array} props.secciones
     */
    constructor(props) {
        $('#empresa_ids').select2();

        $('.btn-editar').click(function () {
            let id = this.parentNode.dataset.id;
            let formModal = new AdminLicenciaActivadaForm({grados: props.grados, secciones: props.secciones});
            formModal.editar(id, {
                onSuccess: function() {
                    window.location.reload();
                }
            });
        });

        $('#btn-limpiar').click(function () {
            window.location.href = window.location.origin + window.location.pathname;
        });

        $('#btn-buscar').click(function () {
            window.location.href = window.location.origin + window.location.pathname + '?' + $('#form-buscar').serialize();
        });

        $('.btn-enviar-correo').click(function () {
            let id = this.parentNode.dataset.id;
            let respuesta = window.confirm('¿Enviar correo?');
            if (respuesta) {
                let btn = this;
                btn.disabled = true;
                Licencia.enviarCorreo(id, {
                    then: function (response) {
                        window.alert(response.data.message);
                    },
                    fail: function (error) {
                        window.alert(error.response.data.message);
                    },
                    always: function () {
                        btn.disabled = false
                    },
                });
            }
        });

        $('#btn-exportar').click(function () {
            window.location.href = window.location.origin + '/admin/notificaciones/' + props.notificacionId + '/licencias-excel?' + $('#form-buscar').serialize();
        });

        $('#btn-relacionar-licencias').click(function() {
            let btn = this;
            let txtBtn = this.innerHTML;
            if (window.confirm('¿Desea buscar licencias y relacionarlas?')) {
                btn.innerHTML = '<i class="fas fa-spin fa-spinner"></i> buscando';
                btn.disabled = true;
                Licencia.enlazarNotificacion(props.notificacionId, {
                    then: function (response) {
                        $.notify(response.data.message, 'success');
                        if (response.data.count > 0) {
                            window.location.reload();
                        }
                    },
                    fail: function (error) {
                        $.notify(error.response.data.message, 'danger');
                    },
                    always: function () {
                        btn.disabled = false;
                        btn.innerHTML = txtBtn;
                    },
                });
            }
        });

        $('#btn-notificar').click(function() {
            let btn = this;
            let txtBtn = this.innerHTML;
            if (window.confirm('¿Desea notificar?, ya no podrá agregar licencias a esta notificación')) {
                btn.innerHTML = '<i class="fas fa-spin fa-spinner"></i> guardando';
                btn.disabled = true;
                NotificacionService.notificar(props.notificacionId, {
                    then: function (response) {
                        $.notify('Notificación realizada', 'success');
                        setTimeout(function() {
                            window.location.reload();
                        }, 2000);
                    },
                    fail: function (error) {
                        $.notify(error.response.data.message, 'danger');
                    },
                    always: function () {
                        btn.disabled = false;
                        btn.innerHTML = txtBtn;
                    },
                });
            }
        });
    }
}
